<template>
  <div class="row">
    <div class="col-sm-6">
      <FormTimePicker
        v-model="startTime"
        label="Start Time"
        @input="handleChange"
      />
    </div>
    <div class="col-sm-6">
      <FormTimePicker
        v-model="endTime"
        label="End Time"
        @input="handleChange"
      />
    </div>
    <div class="col-sm-12">
      <p v-if="!valid" class="text-danger">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import FormTimePicker from '@/components/form/FormTimePicker';
import moment from 'moment';

export default {
  components: {
    FormTimePicker,
  },
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({ startTime: '09:00', endTime: '09:30' }),
    },
    maxSlotLength: {
      type: Number,
      required: false,
      default: 60,
    },
  },
  data() {
    return {
      valid: true,
      errorMessage: '',
      startTime: this.value.startTime,
      endTime: this.value.endTime,
    }
  },
  methods: {
    handleChange() {
      this.validate();
      this.$emit('input', {
        startTime: this.startTime,
        endTime: this.endTime,
      })
    },
    /*
    Slot cannot be longer than {{ maxSlotLength }}mins.
     */
    validate() {
      const startTime = moment(this.startTime, 'HH:mm:ss');
      const endTime = moment(this.endTime, 'HH:mm:ss');

      const slotDurationMins = moment.duration(endTime.diff(startTime)).asMinutes();

      // Check endDate is not before startDate
      if (slotDurationMins <= 0) {
        this.errorMessage = 'End Time cannot be before Start Time'
        this.valid = false;
      } else if (slotDurationMins >= this.maxSlotLength) {
        this.valid = false;
        this.errorMessage = `Slot cannot be longer than ${this.maxSlotLength}mins.`
      } else {
        this.errorMessage = '';
        this.valid = true;
      }
      this.$emit('valid', this.valid);
    },
  },
}
</script>

<style>
</style>
